
<template>
    <header
    class="flex items-center justify-between px-6 py-2 bg-white dark:bg-gray-800 border-b-4 border-indigo-500"
    >
    <div class="flex items-center">
        <button
            class="text-gray-500 dark:text-gray-300 focus:outline-none lg:hidden"
            @click="toggleMenu()"
        >
            <svg
                class="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                d="M4 6H20M4 12H20M4 18H11"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </button>

        <!-- <div class="relative mx-4 lg:mx-0">
            <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg class="w-5 h-5 text-gray-500" viewBox="0 0 24 24" fill="none">
                <path
                d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                </svg>
            </span>

            <input
            class="w-32 pl-10 pr-4 text-indigo-600 border-gray-200 rounded-md sm:w-64 focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
            type="text"
            placeholder="Buscar..."
            >
        </div> -->
    </div>

    <div class="flex items-center">
        <!-- <button class="flex mx-4 text-gray-600 focus:outline-none">
            <svg
                class="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button> -->
        <button
            type="button"
            class="mr-3 flex items-center justify-center w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 focus:outline-none"
            :title="isDark ? 'Modo claro' : 'Modo oscuro'"
            @click="toggleTheme"
            >
            <i class="fa-solid" :class="isDark ? 'fa-sun' : 'fa-moon'"></i>
        </button>
        <div class="mr-3 pt-2 dark:text-gray-100">{{currentUser.name}}</div>
            <div class="relative">
                    <button
                        class="relative z-10 flex items-center justify-center w-8 h-8 rounded-full shadow bg-gray-300 text-white focus:outline-none"
                        @click="dropdownOpen = !dropdownOpen"
                        >
                        <i class="fas fa-user text-gray-800 fa-xl mx-1  cursor-pointer"></i>
                    </button>

                <div
                    v-show="dropdownOpen"
                    class="fixed inset-0 z-10 w-full h-full"
                    @click="dropdownOpen = false"
                    />

                    <transition
                    enter-active-class="transition duration-150 ease-out transform"
                    enter-from-class="scale-95 opacity-0"
                    enter-to-class="scale-100 opacity-100"
                    leave-active-class="transition duration-150 ease-in transform"
                    leave-from-class="scale-100 opacity-100"
                    leave-to-class="scale-95 opacity-0"
                    >
                    <div
                        v-show="dropdownOpen"
                        class="absolute right-0 z-20 w-48 py-2 mt-2 bg-white dark:bg-gray-800 rounded-md shadow-xl"
                        >
                        <span @click="editProfile" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:text-blue-800 dark:hover:text-blue-400">
                           Mis datos
                        </span>
                        <span @click="openChangePassword" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:text-blue-800 dark:hover:text-blue-400">
                            Cambiar contraseña
                        </span>
                        <span @click="closeSession" class="cursor-pointer block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:text-blue-800 dark:hover:text-blue-400">
                            Cerrar sesión
                        </span>
                    </div>
                </transition>
            </div>
        </div>

    <teleport to="body">
        <div
            v-if="changePasswordModalOpen"
            class="fixed inset-0 z-50 flex items-center justify-center p-4"
            >
            <div
                class="absolute inset-0 bg-black/40"
                @click="closeChangePasswordModal"
                />
            <div
                class="relative z-10 w-full max-w-md rounded-lg bg-white dark:bg-gray-800 p-6 shadow-xl"
                @click.stop
                >
                <h2 class="mb-4 text-lg font-semibold text-gray-800 dark:text-gray-100">Cambiar contraseña</h2>
                <form @submit.prevent="submitChangePassword">
                    <label class="mb-3 block">
                        <span class="mb-1 block text-sm text-gray-600 dark:text-gray-300">Contraseña actual</span>
                        <input
                            v-model="pwdForm.current_password"
                            type="password"
                            autocomplete="current-password"
                            class="w-full rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            required
                            />
                    </label>
                    <label class="mb-3 block">
                        <span class="mb-1 block text-sm text-gray-600 dark:text-gray-300">Nueva contraseña (mín. 8 caracteres)</span>
                        <input
                            v-model="pwdForm.new_password"
                            type="password"
                            autocomplete="new-password"
                            class="w-full rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            required
                            minlength="8"
                            />
                    </label>
                    <label class="mb-4 block">
                        <span class="mb-1 block text-sm text-gray-600 dark:text-gray-300">Repetir nueva contraseña</span>
                        <input
                            v-model="pwdForm.confirm_password"
                            type="password"
                            autocomplete="new-password"
                            class="w-full rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            required
                            />
                    </label>
                    <p v-if="changePasswordError" class="mb-3 text-sm text-red-600">{{ changePasswordError }}</p>
                    <p v-if="changePasswordSuccess" class="mb-3 text-sm text-green-700">{{ changePasswordSuccess }}</p>
                    <div class="flex justify-end gap-2">
                        <button
                            type="button"
                            class="rounded px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
                            @click="closeChangePasswordModal"
                            >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            class="rounded bg-indigo-600 px-4 py-2 text-sm text-white hover:bg-indigo-700 disabled:opacity-50"
                            :disabled="changePasswordSubmitting"
                            >
                            {{ changePasswordSubmitting ? 'Guardando…' : 'Guardar' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </teleport>
    </header>
</template>


<script>
import {  mapGetters } from 'vuex'
import { changePassword } from '@/service/auth.service'

export default {

    data() {
        return  {
            dropdownOpen :false,
            changePasswordModalOpen: false,
            changePasswordSubmitting: false,
            changePasswordError: '',
            changePasswordSuccess: '',
            pwdForm: {
                current_password: '',
                new_password: '',
                confirm_password: ''
            }
        }
    },
    computed: {
        ...mapGetters('authentication', ['currentUser']),
        isDark() {
            return this.$store.state.theme.dark
        }
    },
    methods: {
        toggleTheme() {
            this.$store.dispatch('theme/toggle')
        },
        async closeSession() {
             try {
                const response = await this.$store.dispatch('authentication/logout', this.formLogin)
                if(response.status === 'error'){
                    console.log('error found...');
                } else {
                    this.dropdownOpen = false
                    this.$router.replace({name: 'login'})
                }
            } catch (error) {
                console.log(error)
            }
        },
        toggleMenu() {
            this.$emit('toggleMenu')
        },
        editProfile(){
            this.dropdownOpen = false
            this.$router.push({name: 'editProfile', params:{id: this.currentUser.user_id }})
        },
        openChangePassword() {
            this.dropdownOpen = false
            this.changePasswordModalOpen = true
            this.changePasswordError = ''
            this.changePasswordSuccess = ''
            this.pwdForm = {
                current_password: '',
                new_password: '',
                confirm_password: ''
            }
        },
        closeChangePasswordModal() {
            if (this.changePasswordSubmitting) return
            this.changePasswordModalOpen = false
            this.changePasswordError = ''
            this.changePasswordSuccess = ''
            this.pwdForm = {
                current_password: '',
                new_password: '',
                confirm_password: ''
            }
        },
        async submitChangePassword() {
            this.changePasswordError = ''
            this.changePasswordSuccess = ''
            if (this.pwdForm.new_password.length < 8) {
                this.changePasswordError = 'La nueva contraseña debe tener al menos 8 caracteres.'
                return
            }
            if (this.pwdForm.new_password !== this.pwdForm.confirm_password) {
                this.changePasswordError = 'Las contraseñas nuevas no coinciden.'
                return
            }
            if (this.pwdForm.new_password === this.pwdForm.current_password) {
                this.changePasswordError = 'La nueva contraseña debe ser distinta de la actual.'
                return
            }
            this.changePasswordSubmitting = true
            try {
                await changePassword({
                    current_password: this.pwdForm.current_password,
                    new_password: this.pwdForm.new_password
                })
                this.changePasswordSuccess = 'Contraseña actualizada correctamente.'
                setTimeout(() => {
                    this.closeChangePasswordModal()
                }, 1200)
            } catch (err) {
                const msg = err.response?.data?.message || err.response?.data?.error
                this.changePasswordError =
                    typeof msg === 'string' ? msg : 'No se pudo cambiar la contraseña. Comprueba la contraseña actual.'
            } finally {
                this.changePasswordSubmitting = false
            }
        }
    }

}
</script>